module.exports = __webpack_public_path__ + "img/III-304.1.d6627a1e.svg";